import React from "react";
import { Image, Text, View } from "react-native";
import { AppImages } from "../utility/AppImages";
import { AppColors } from "../utility/AppColors";
import { AppFontStyle } from "../styles/AppFontStyle";
import { useTooltips } from "../context/WalkthroughContext";
import ChatWalkthrough from "../Components/walk-through-common-components/homeScreenTooltips/ChatWalkthrough";
import NotificationWalkthrough from "../Components/walk-through-common-components/homeScreenTooltips/NotificationWalkthrough";
import { NotificationBadge } from "../Components/NotificationBadge";
import { useNotifications } from "../context/NotificationContext";

const CustomNotificationFooterDrawer = ({ toggleMoreModal, focused }) => {
  const { homeWalkThroughVisible } = useTooltips();
  const { notificationCounts } = useNotifications();
  const totalNotificationCount = notificationCounts.total;
  const iconColor = focused ? AppColors.buttonRed_DC2626 : "#FFFFFF";
  const textColor = focused ? AppColors.buttonRed_DC2626 : "#FFFFFF";

  return homeWalkThroughVisible ? (
    <NotificationWalkthrough
      toggleMoreModal={toggleMoreModal}
      content={
        <View
          style={{
            paddingVertical: 5,
            gap: 5,
            alignItems: "center",
            position: "relative",
          }}
        >
          <View style={{ position: "relative" }}>
            <Image
              source={AppImages.icNotificationbing}
              style={{
                width: 27,
                height: 27,
                resizeMode: "contain",
                tintColor: iconColor,
              }}
            />
            <NotificationBadge
              count={totalNotificationCount}
              size="small"
              position="topRight"
              isVisible={totalNotificationCount > 0}
            />
          </View>
          <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: textColor }]}>Notification</Text>
        </View>
      }
    />
  ) : (
    <View
      style={{
        padding: 10,
        gap: 5,
        alignItems: "center",
        position: "relative",
      }}
    >
      <View style={{ position: "relative" }}>
        <Image
          source={AppImages.icNotificationbing}
          style={{
            width: 27,
            height: 27,
            resizeMode: "contain",
            tintColor: iconColor,
          }}
        />
        <NotificationBadge
          count={totalNotificationCount}
          size="small"
          position="topRight"
          isVisible={totalNotificationCount > 0}
        />
      </View>
      <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: textColor }]}>Notification</Text>
    </View>
  );
};

export default CustomNotificationFooterDrawer;
